/**
 * Gets the computed boolean value of the React Hook Form required option.
 *
 * @param required The React Hook Form required option.
 */
export function getIsHookFormOptionRequired(required) {
    if (!required ||
        typeof required === 'boolean' ||
        typeof required === 'string') {
        return !!required;
    }
    return required.value;
}
